// extracted by mini-css-extract-plugin
module.exports = {"spinner_container":"LoadingSpinner_spinner_container__jT5cw","spinner":"LoadingSpinner_spinner__WhwLC","spin":"LoadingSpinner_spin__WxHNL"};